/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1506
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
var r
var i = Object.assign || function (e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t]
    for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r)) {
      e[r] = n[r]
    }
  }
  return e
}
var o = require(/* 0 */"react")
var a = (r = o) && r.__esModule ? r : {
  default: r
}
exports.default = function (e) {
  var /* [auto-meaningful-name] */e$fill = e.fill
  var n = undefined === e$fill ? "currentColor" : e$fill
  var /* [auto-meaningful-name] */e$width = e.width
  var o = undefined === e$width ? 24 : e$width
  var /* [auto-meaningful-name] */e$height = e.height
  var c = undefined === e$height ? 24 : e$height
  var /* [auto-meaningful-name] */e$style = e.style
  var l = undefined === e$style ? {} : e$style
  var f = function (e, t) {
    var n = {}
    for (var r in e) if (!(t.indexOf(r) >= 0)) {
      if (Object.prototype.hasOwnProperty.call(e, r)) {
        n[r] = e[r]
      }
    }
    return n
  }(e, ["fill", "width", "height", "style"])
  return a.default.createElement("svg", i({
    viewBox: "0 0 24 24",
    style: i({
      fill: n,
      width: o,
      height: c
    }, l)
  }, f), a.default.createElement("path", {
    d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
  }))
}
